const roomStyle = (trackId) => {
    return {
        gridColumn: `track-${trackId}`,
        gridRow: 'tracks',
        //height: '70%',
    }
}

const Rooms = ({rooms}) => {

    return (
        <>
            {
                rooms?.filter(x => x.id !== 0).map((room, key) => {
                    return (
                        <span key={key} className="track-slot" aria-hidden="true"
                              style={roomStyle(room.id)}>{room.name}</span>
                    )
                })
            }
        </>
    )
}
export default Rooms;